import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { TripFinanceReportTab } from './TripFinanceReportTab';
import { MonthlyFinanceReportTab } from './MonthlyFinanceReportTab';
import { YearlyFinanceReportTab } from './YearlyFinanceReportTab';
import { FinanceSummaryTab } from './FinanceSummaryTab';
import { PayrollReportTab } from './PayrollReportTab';

type TabType = 'trip' | 'monthly' | 'yearly' | 'summary' | 'payroll';

export const FinanceReportsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('summary');

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-neutral-charcoal">Finance Reports</h1>
        <p className="text-gray-600">View comprehensive financial reports and analytics</p>
      </div>

      <Card>
        <div className="border-b border-gray-200">
          <nav className="flex space-x-4 px-6 -mb-px">
            <button
              onClick={() => setActiveTab('summary')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'summary'
                  ? 'border-primary-green text-primary-green'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Summary
            </button>
            <button
              onClick={() => setActiveTab('trip')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'trip'
                  ? 'border-primary-green text-primary-green'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Trip Reports
            </button>
            <button
              onClick={() => setActiveTab('monthly')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'monthly'
                  ? 'border-primary-green text-primary-green'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Monthly Reports
            </button>
            <button
              onClick={() => setActiveTab('yearly')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'yearly'
                  ? 'border-primary-green text-primary-green'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Yearly Reports
            </button>
            <button
              onClick={() => setActiveTab('payroll')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'payroll'
                  ? 'border-primary-green text-primary-green'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Payroll Reports
            </button>
          </nav>
        </div>

        <div className="p-6">
          {activeTab === 'summary' && <FinanceSummaryTab />}
          {activeTab === 'trip' && <TripFinanceReportTab />}
          {activeTab === 'monthly' && <MonthlyFinanceReportTab />}
          {activeTab === 'yearly' && <YearlyFinanceReportTab />}
          {activeTab === 'payroll' && <PayrollReportTab />}
        </div>
      </Card>
    </div>
  );
};
